export default __webpack_public_path__ + "static/media/icon-report.svg";